var rtl_rtlignore_default = {
  "rtl": "_7szEa",
  "ltr": "M6Vf-"
};
export {
  rtl_rtlignore_default as default
};
//# sourceMappingURL=rtl.rtlignore-scss.js.map
